/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * station object
 * @export
 * @interface PostUniverseIdsStation
 */
export interface PostUniverseIdsStation {
    /**
     * id integer
     * @type {number}
     * @memberof PostUniverseIdsStation
     */
    id?: number;
    /**
     * name string
     * @type {string}
     * @memberof PostUniverseIdsStation
     */
    name?: string;
}

/**
 * Check if a given object implements the PostUniverseIdsStation interface.
 */
export function instanceOfPostUniverseIdsStation(value: object): value is PostUniverseIdsStation {
    return true;
}

export function PostUniverseIdsStationFromJSON(json: any): PostUniverseIdsStation {
    return PostUniverseIdsStationFromJSONTyped(json, false);
}

export function PostUniverseIdsStationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUniverseIdsStation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PostUniverseIdsStationToJSON(json: any): PostUniverseIdsStation {
    return PostUniverseIdsStationToJSONTyped(json, false);
}

export function PostUniverseIdsStationToJSONTyped(value?: PostUniverseIdsStation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

